import parse from "html-react-parser";
import CardsContainer from "../../../Plans/Contents/CardsContainer";
import { memo } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import { LinkToNewTab } from "../../../../Elements/Link/Link";

import styles from "./styles.module.scss";

const PlanCards = memo(() => {
  const { getTextByKey } = useContent();

  return (
    <div className={styles.plansContainer}>
      <div className={styles.orDivContainer}>
        <div className={styles.orLine}></div>
        <div className={styles.divText}>{getTextByKey("or")}</div>
        <div className={styles.orLine}></div>
      </div>
      <div className={styles.topText}>
        {parse(getTextByKey("ready-unlock-perks"))}
      </div>
      <div className={styles.plansCardsContainer}>
        <CardsContainer isYearly={true} setClickedCard={() => {}} />
      </div>
      <div className={styles.seeAllFeatures}>
        <LinkToNewTab
          isNewTab
          page="plans?r=true"
          classes={undefined}
          style={undefined}
          ariaLabel={undefined}
        >
          {getTextByKey("see-all-features")}
        </LinkToNewTab>
      </div>
    </div>
  );
});

export default PlanCards;
